import { default as ConnectSwitch } from './ConnectSwitch'
import { default as DateTimeComponent } from './DateTimeComponent'
import { default as ApplicationOwner } from './ApplicationOwner'
import { default as ResourceImage } from './ResourceImage'
import { default as HighlightedClickableLabel } from './HighlightedClickableLabel'
import { default as DateTimeGenericComponent } from './DateTimeGenericComponent'
import { default as PersonComponent } from './PersonComponent'
import { default as BooleanValue } from './BooleanValue'
import { default as BooleanIcon } from './BooleanIcon'
import { default as CalculateTimeString } from './CalculateTimeString'
import { default as GroupChangeType } from './GroupChangeType'
import { default as AddEditTimeConstraint } from './AddEditTimeConstraint'
import { default as DynamicToggleSwitch } from './DynamicToggleSwitch'

const DynamicComponents = {
    ConnectSwitch,
    DateTimeComponent,
    ApplicationOwner,
    ResourceImage,
    HighlightedClickableLabel,
    DateTimeGenericComponent,
    PersonComponent,
    BooleanValue,
    BooleanIcon,
    CalculateTimeString,
    GroupChangeType,
    AddEditTimeConstraint,
    DynamicToggleSwitch,
}

export default DynamicComponents
